import { common } from "../../constants/actionTypes";

const INITIAL_STATE = {
  countryListData: [],
  stateListData: [],
  cityListData: [],
  loader: false,
  notificationTicket: "",
  socketTicket: "",
  dashboardTicket: "",
  sidebarCollapsed: false,
  sidebarHidden: false,
};

const myLabsReducer = (state = INITIAL_STATE, action = {}) => {
  switch (action.type) {
    case common.COUNTRY_LIST_GET_SUCCESS:
      return {
        ...state,
        countryListData: action.data,
      };
    case common.STATE_LIST_GET_SUCCESS:
      return {
        ...state,
        stateListData: action.data,
      };
    case common.CITY_LIST_GET_SUCCESS:
      return {
        ...state,
        cityListData: action.data,
      };
    case common.COMMON_LOADER_GET_REQUEST:
      return {
        ...state,
        loader: true,
      };
    case common.COMMON_LOADER_GET_SUCCESS:
      return {
        ...state,
        loader: false,
      };
    case common.SET_WEBSOCKET_TICKET:
      return {
        ...state,
        socketTicket: action?.data?.id,
      };

    case common.SET_NOTIFICATION_WEBSOCKET_TICKET:
      return {
        ...state,
        notificationTicket: action?.data?.id,
      };
    case common.CLEAR_TICKET:
      return {
        ...state,
        socketTicket: action.data,
      };
    case common.SET_DASHBOARD_WEBSOCKET_TICKET:
      return {
        ...state,
        dashboardTicket: action?.data?.id,
      };
    case common.SET_IS_DARK_THEME:
      return {
        ...state,
        isDarkTheme: action?.data,
      };
    case common.SET_IS_SIDEBAR_COLLAPSE:
      return {
        ...state,
        sidebarCollapsed: action?.data,
      };
    case common.SET_IS_SIDEBAR_HIDDEN:
      return {
        ...state,
        sidebarHidden: action?.data,
      };
    default:
      return state;
  }
};

export default myLabsReducer;
